import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { OpenFeature } from '@openfeature/react-sdk';

export const isCopyPlainTextStripEnabled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'release-scribe-copy-plain-text-strip',
    false
  );
